import type { SVGProps } from "react";
// generated from Logistic.svg — do not edit manually
// prettier-ignore
export default function Logistic(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M9.33301 4.66667C9.33301 6.13943 10.5269 7.33333 11.9997 7.33333C13.4724 7.33333 14.6663 6.13943 14.6663 4.66667C14.6663 3.19391 13.4724 2 11.9997 2C10.5269 2 9.33301 3.19391 9.33301 4.66667ZM9.33301 4.66667H1.33301M6.66634 11.3333C6.66634 12.8061 5.47243 14 3.99967 14C2.52692 14 1.33301 12.8061 1.33301 11.3333C1.33301 9.86057 2.52692 8.66667 3.99967 8.66667C5.47243 8.66667 6.66634 9.86057 6.66634 11.3333ZM6.66634 11.3333H14.6663" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
